import { render, staticRenderFns } from "./AdvisoryInsight.vue?vue&type=template&id=3c9eb91e&scoped=true"
import script from "./AdvisoryInsight.vue?vue&type=script&lang=js"
export * from "./AdvisoryInsight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c9eb91e",
  null
  
)

export default component.exports